import { jsonProperty, Serializable } from 'ts-serializable';
import type { Nullable } from './BaseTypes';

export class TripStudent extends Serializable {
    @jsonProperty(String) id: Nullable<string> = null;
    @jsonProperty(String) name: Nullable<string> = null;
    @jsonProperty(String) studentId: Nullable<string> = null;
    @jsonProperty(String) studentName: Nullable<string> = null;
    @jsonProperty(String) tripId: Nullable<string> = null;
    @jsonProperty(String) tripName: Nullable<string> = null;
    @jsonProperty(String) clientId: Nullable<string> = null;
    @jsonProperty(String) clientName: Nullable<string> = null;
    @jsonProperty(String) nameOfAccompanying: Nullable<string> = null;
    @jsonProperty(String) surnameOfAccompanying: Nullable<string> = null;
    @jsonProperty(Boolean) accompaniedByAParent: boolean = true;
    @jsonProperty(String) phoneNumber: Nullable<string> = null;
    @jsonProperty([String]) kinship: string[] = [];
    @jsonProperty(Boolean) isweGetThereOnOurOwn: boolean = false;
}
